module.exports = __webpack_public_path__ + "static/media/1.253cca10.jpg";